"use client";

/**
 * Reusable pagination control.
 * Usage: <Pagination page={page} totalPages={n} onChange={setPage} isAr={isAr} />
 * Renders nothing when there's only one page.
 */
export default function Pagination({
  page,
  totalPages,
  onChange,
  isAr = true,
  className = "",
}: {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  isAr?: boolean;
  className?: string;
}) {
  if (!totalPages || totalPages <= 1) return null;
  const t = (a: string, e: string) => (isAr ? a : e);

  const Icon = ({ name }: { name: string }) => (
    <span className="material-symbols-outlined text-[18px]">{name}</span>
  );

  const btn =
    "flex items-center gap-1 rounded-full border border-clay-100 bg-surface px-4 py-2 text-sm font-bold text-ink-900 disabled:opacity-40 hover:bg-clay-50 transition-colors";

  return (
    <div className={`flex items-center justify-center gap-3 mt-12 ${className}`}>
      <button onClick={() => onChange(Math.max(1, page - 1))} disabled={page <= 1} className={btn}>
        <Icon name={isAr ? "chevron_right" : "chevron_left"} />
        {t("السابق", "Prev")}
      </button>
      <span className="text-sm font-bold text-ink-900">
        {page} / {totalPages}
      </span>
      <button
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className={btn}
      >
        {t("التالي", "Next")}
        <Icon name={isAr ? "chevron_left" : "chevron_right"} />
      </button>
    </div>
  );
}
